import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import * as authParentService from '../admin/services/authParentService'
import Swal from "sweetalert2";
import { Password } from 'primereact/password';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import * as authService from '../admin/services/authParentService'
import { Button } from 'primereact/button';
import { ConfirmCode } from '../components/ConfirmCode';
import { PairUpWithAuthenticators } from '../components/PairUpWithAuthenticators';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import { EmailConfirmation } from '../components/EmailConfirmation';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';

export function ParentLogin() {

    const { onLogin } = useContext(AuthContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    const [verfy2FA, setVerify2FA] = useState({
        success: '',
        requires2FA: '',
    })

    const [data2FA, setData2FA] = useState({
        egn: '',
        code: '',
    });

    const [formData, setFormData] = useState({
        egn: '',
        password: '',
    });

    //Рендериране на кепча
    //useEffect(() => {
    //    if (verfy2FA.fact) {
    //        loadCaptchaEnginge(6);
    //    }

    //}, [verfy2FA]);

    document.title = `Вход`;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleChange2FA = (e) => {
        setData2FA(state => ({
            egn: formData.egn,
            code: e.target.value
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        authParentService.login(formData)
            .then(data => {
                if (data.token) {
                    sessionStorage.setItem("tempToken", data.token)
                }

                setVerify2FA(data)
                setLoading(false);

            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);

            });

    }

    //Authenticator
    const submitChange2FAMethod = (e) => {
        e.preventDefault();

        Swal.fire({
            title: "Внимание !",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Напред",
            cancelButtonText: "Отказ",
            html:
                `<div style="display: flex; align-items: center; justify-content: left; flex-wrap:wrap; width: 100%;">
                    <p style="width:100%; color: red;  font-weight: bold;">С цел повишаване на сигурността и опазване на Вашите лични данни въвеждаме допълнителни проверки при вход в системата.</p>
                    <p style="width:100%; color: red;  font-weight: bold;">Моля, изберете метод за двуфакторна автентикация</p>
                    <div style="display: flex; align-items: center; gap: 5px; width:100%;">
                        <input type="radio" id="Authenticator" name="authMethod" value="2" checked>
                        <label for="Authenticator">Google/Microsoft Authenticator</label>
                    </div>
                    <div style="display: flex; align-items: center; gap: 5px; width:100%;">
                        <input type="radio" id="Email" name="authMethod" value="3">
                        <label for="Email">Код на имейл</label>
                    </div>
                    <div style="display: flex; align-items: center; gap: 5px; width:100%;">
                        <input type="radio" id="Fact" name="authMethod" value="1">
                        <label for="Fact">Факт от заявление</label>
                    </div>
                </div>`,
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                const selectedMethod = document.querySelector('input[name="authMethod"]:checked').value;

                authParentService.change2FAMethod({ egn: formData.egn, twoFactorType: Number(selectedMethod) })
                    .then(data => {
                        if (data.token) {
                            sessionStorage.setItem("tempToken", data.token)
                        }

                        setVerify2FA(data)
                        setLoading(false);
                    })
                    .catch((error) => {
                        Swal.fire({
                            title: "Възникна грешка",
                            text: error.message,
                            icon: "warning",
                            button: "Добре",
                        });
                        setLoading(false);

                    });

            }
        });
    }

    const scanAgain = (e) => {
        e.preventDefault();
        setLoading(true);

        authParentService.scanCodeForAuthenticatorAgain({ egn: formData.egn })
            .then(data => {
                setVerify2FA(data)
                setLoading(false);

            })
            .catch((error) => {
                Swal.fire({
                    title: "Възникна грешка",
                    text: error.message,
                    icon: "warning",
                    button: "Добре",
                });
                setLoading(false);

            });
    }

    const submitVerify2FA = (e) => {
        e.preventDefault();
        setLoading(true);
        if (verfy2FA.type2FA == 1) {
            if (!formData.fact) {
                Swal.fire({
                    title: "Възникна грешка",
                    text: `${verfy2FA.fact} е задължителен`,
                    icon: "error",
                    button: "Добре",
                });
                setLoading(false);

                return
            }

            //Провекра за кепча 
            //if (validateCaptcha(formData.captcha, false) !== true) {
            //    Swal.fire({
            //        title: "Грешно попълнени символи от картинката!",
            //        icon: "error",
            //    });
            //    setLoading(false);

            //    return;
            //}

            const data = {
                egn: formData.egn,
                code: formData.fact,
                regId: verfy2FA.regId,
                factNumber: verfy2FA.factNumber,
            }

            authService.verifyFact(data)
                .then((data) => {
                    onLogin(data)
                    setLoading(false);

                    navigate('/parent/');
                })
                .catch((err) => {
                    Swal.fire({
                        title: "Възникна грешка",
                        text: err.message,
                        icon: "error",
                        button: "Добре",
                    });
                    setLoading(false);

                    console.log(err)
                })
        } else if (verfy2FA.type2FA == 2) {
            authService.verify2FALogin(data2FA)
                .then((data) => {
                    onLogin(data)
                    setLoading(false);

                    navigate('/parent/');
                })
                .catch((err) => {
                    Swal.fire({
                        title: "Възникна грешка",
                        text: err.message,
                        icon: "error",
                        button: "Добре",
                    });
                    setLoading(false);

                    console.log(err)
                })
        } else if (verfy2FA.type2FA == 3) {
            authService.verifyEmailLogin(data2FA)
                .then((data) => {
                    onLogin(data)
                    setLoading(false);

                    navigate('/parent/');
                })
                .catch((err) => {
                    Swal.fire({
                        title: "Възникна грешка",
                        text: err.message,
                        icon: "error",
                        button: "Добре",
                    });
                    setLoading(false);

                    console.log(err)
                })
        }
    }



    const sendEmailCodeAgain = (e) => {
        e.preventDefault();
        setLoading(true);

        authService.resendEmailCode(formData.egn)
            .then((data) => {
                Swal.fire({
                    title: "Успешно изпращане",
                    text: "Кодът е изпратен успешно на имейл",
                    icon: "success",
                    button: "Добре",
                });
                setLoading(false);
            })
            .catch((err) => {
                console.log(err)
                setLoading(false);

            })
    }

    const loginKEP = (e) => {
        e.preventDefault();
        setLoading(true);

        const domain = window.location.href.split('/parent-login')[0];
        
        window.location.href = `${domain}/api/Auth/redirectToStampIT`;
        //window.location.href = `https://localhost:7127/api/Auth/redirectToStampIT`;

    }

    return (
        <div className="flex justify-center items-center min-h-screen px-4">
            <div className="color-bg-cl login-width mx-auto border border-gray-400 p-4 rounded mt-5">
                <div className="title_entr">{verfy2FA && verfy2FA.email && verfy2FA.requires2FA ? 'Изпратихме Ви код' : 'Вход в системата'}</div>
                <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
                {verfy2FA.requires2FA && !verfy2FA.secretKey
                    ? <ConfirmCode
                        verfy2FA={verfy2FA}
                        data2FA={data2FA}
                        handleChange2FA={handleChange2FA}
                        submitVerify2FA={submitVerify2FA}
                        sendEmailCodeAgain={sendEmailCodeAgain}
                        submitChange2FAMethod={submitChange2FAMethod}
                        scanAgain={scanAgain}
                    />
                    : verfy2FA.secretKey && verfy2FA.qrCodeUri
                        ? <PairUpWithAuthenticators
                            username={formData.egn}
                            verfy2FA={verfy2FA}
                            data2FA={data2FA}
                            handle2FAChange={handleChange2FA}
                            submitVerify2FA={submitVerify2FA}
                            submitChange2FAMethod={submitChange2FAMethod}
                            isInAdmin={false}
                        />

                        :  < div className="login_form">

                                <form className="form" id="login" method="post" action="login">

                                    {!verfy2FA.fact &&
                                        <div className="form-group">
                                            <div className="input-group">
                                                <span className="p-float-label labels">
                                                    <InputText name='egn' id="egn" style={{ width: '100%' }} value={formData.egn} onChange={handleChange} />
                                                    <label htmlFor="pass">ЕГН на родител*</label>
                                                </span>
                                            </div>
                                        </div>
                                    }



                                    <div className="form-group w-100 mt-3">

                                        <div className="input-group w-100">

                                            {!verfy2FA.fact &&
                                                <>
                                                    <span className="p-float-label labels">
                                                        <Password
                                                            inputId="pass"
                                                            name='password'
                                                            value={formData.password}
                                                            onChange={handleChange}
                                                            feedback={false}
                                                            toggleMask
                                                            className={`${formData.password.length > 5 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                                                        />
                                                        <label htmlFor="pass">Парола*</label>
                                                    </span>


                                                    <Link className='w-100' to={`/forgotten-password`}>
                                                        <div className="forg_pass text-end w-100">Забравена парола</div>
                                                    </Link>
                                                </>
                                            }

                                            {verfy2FA.fact &&
                                                <>
                                                    <span className="p-float-label labels mt-4">
                                                        <InputText name='fact' id="fact" style={{ width: '100%' }} value={formData.fact} onChange={handleChange} />

                                                        <label htmlFor="pass">{verfy2FA.fact}</label>
                                                    </span>



                                                </>

                                            }

                                            <div className={`input-group mt-4 ${verfy2FA.fact ? '' : 'd-none'} `}>

                                                {/*<div className="w-100">*/}
                                                {/*    <LoadCanvasTemplate reloadText="Презареди символи" reloadColor="black" />*/}
                                                {/*</div>*/}

                                                {/*<span className="p-float-label labels mt-4">*/}
                                                {/*    <InputText name='captcha' id="captcha" style={{ width: '100%' }} value={formData.captcha} onChange={handleChange} />*/}
                                                {/*    <label htmlFor="pass">Въведете символите</label>*/}
                                                {/*</span>*/}

                                                <p className='w-100 text-start mt-4'>Можете да смените вида на двуфакторната автентикация от <span className="btn-link p-0 m-0" onClick={submitChange2FAMethod}>ТУК</span></p>
                                            </div>
                                        </div>

                                    </div>


                                    <div className="form-group d-flex flex-wrap justify-content-center items-center">
                                        <Button
                                            label={`${verfy2FA.fact ? 'Вход' : 'Вход с парола'}` }
                                            severity="danger"
                                            raised
                                            className='btn-prim mt-4 w-100 w-100-mob'
                                            onClick={verfy2FA.fact ? submitVerify2FA : onSubmit}
                                        />
                                        {!verfy2FA.fact &&
                                            <>
                                                <p className='w-100 m-0 mt-3 text-center fw-bolder'>ИЛИ</p>
                                                <Button
                                                    label="Вход с електронен подпис"
                                                    severity="danger"
                                                    raised
                                                    className='btn-prim mt-3 w-100 w-100-mob'
                                                    onClick={loginKEP}
                                                />
                                                <p className='w-100 text-start mt-4'>Използването на електронен подпис за вход предоставя най-високо ниво на сигурност и елиминира необходимостта от двуфакторно удостоверяване.</p>
                                            </>
                                        }

                                    </div>

                                </form>

                            </div>}


            </div>
        </div>
    );
}

export default ParentLogin;